/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    fieldTaskData : null,
};


const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.GetFieldTaskAction.GET_FIELD_TASK_COMPLETE_COUNT:
      return {
        ...state,
    };
    case actions.GetFieldTaskAction.FIELD_TASK_COMPLETE_RESPONSE:
          return{
      ...state,
      fieldTaskData : action.data,
      // userid: action.payload.user_ID,
      // projectid: action.payload.project_ID,
    };

    default:
      return state;
  }
};

export default reducer;
